module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "break"
  }), _vm._v(" "), _c('p', {
    staticClass: "table2"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ABLES")])]), _vm._v(" "), _c('p', {
    staticClass: "bigspace"
  }), _c('p', {
    staticClass: "table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_chap5#tbl1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ABLE")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NE")])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_chap5#tbl1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Table of Comparisons: Yalkut And Maseket")])]), _vm._v(" "), _c('p', {
    staticClass: "xsmallspace"
  }), _c('p', {
    staticClass: "table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_chap5#tbl2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ABLE")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WO")])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_chap5#tbl2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Table of Comparsions: The Roles of The Relevant Chief Rabbis")])]), _vm._v(" "), _c('p', {
    staticClass: "xsmallspace"
  }), _c('p', {
    staticClass: "table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_chap5#tbl3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ABLE")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HREE")])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_chap5#tbl3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Listing of The Nasi’im (Chief Rabbis) of The Great Sanhedrin")])]), _vm._v(" "), _c('p', {
    staticClass: "xsmallspace"
  }), _c('p', {
    staticClass: "table"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_chap5#tbl4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ABLE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUR")])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_chap5#tbl4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Messianic Jewish “Nasi’im” of This Early Community")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62ab472b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/07_tables.vue
// module id = 75
// module chunks = 0